import { Crosshair } from "lucide-react";
import { ComingSoonPage } from "./ComingSoonPage";

export function MissionsPage() {
  return (
    <ComingSoonPage
      title="Missions"
      description="Plan the outcomes your factory delivers over time."
      Icon={Crosshair}
    />
  );
}
